import { dataProps } from './properties'

export const setPaymentModeList = (state, payload) => {
    state.list = payload
}    

export const setPaymentModeData = (state, payload) => {
    state.props = payload
} 

export const resetPaymentModeData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/paymentMode/mutations.js